import { createRoute } from 'next-typed-routes';

export enum ActivityRoutes {
    Statements = '/activity/statements',
    Transactions = '/activity/transactions'
}

export const activityRoutes = {
    statements: createRoute(ActivityRoutes.Statements),
    transactions: createRoute(ActivityRoutes.Transactions)
};
